import { render } from "./TrackManager.vue?vue&type=template&id=b87f6532&scoped=true&ts=true"
import script from "./TrackManager.vue?vue&type=script&lang=ts"
export * from "./TrackManager.vue?vue&type=script&lang=ts"

import "./TrackManager.vue?vue&type=style&index=0&id=b87f6532&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87f6532"]])

export default __exports__